import angular from 'angular'

/* @ngInject */
const myChooseOrder = (
  $timeout,
  valueHandler,
  toaster,
  labels,
  fields
) => {
  return {
    restrict: 'E',
    scope: {
      myOrder: '=',
      myFields: '=',
      myDefaultOrder: '=?',
    },
    template: require('./myChooseOrder.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.propertyName = ''

      $scope.deleteChip = (_index) => {
        $scope.properties.splice(_index, 1)
        $scope.displayOrder.splice(_index, 1)
        $scope.myOrder.splice(_index, 1)
      }

      $scope.addProperty = (_propertyName) => {
        if (valueHandler.isNull(_propertyName)) {
          toaster.message('Champ invalide', 'orange')
          return
        }

        for (const key in $scope.myFields) {
          if ($scope.myFields.hasOwnProperty(key)) {
            const field = $scope.myFields[key]

            if (field.label === _propertyName) {
              if ($scope.properties.indexOf(field) === -1) {
                $scope.properties.push(field)
                $scope.changeSort(field)
              }
              $scope.propertyName = null
              return
            }
          }
        }

        toaster.message('Champ invalide', 'orange')
      }

      $scope.cleanProperties = () => {
        if (toaster.confirm(labels.ask.deleteSortProperties)) {
          $scope.properties.splice(0, $scope.properties.length)
          $scope.myOrder.splice(0, $scope.myOrder.length)
          $scope.displayOrder.splice(0, $scope.displayOrder.length)
        }
      }

      $scope.changeSort = (_property) => {
        $timeout(() => {
          const index1 = $scope.myOrder.indexOf(_property.ref)
          let index2

          if (index1 === -1) {
            index2 = $scope.myOrder.indexOf('-' + _property.ref)
            if (index2 === -1) {
              $scope.myOrder.push(_property.ref)
            } else {
              const length = $scope.myOrder[index2].length
              $scope.myOrder[index2] = $scope.myOrder[index2].slice(1, length)
            }
          } else {
            index2 = $scope.myOrder.indexOf('-' + _property.ref)
            if (index2 === -1) {
              $scope.myOrder[index1] = '-' + $scope.myOrder[index1]
            } else {
              return 0
            }
          }

          if (index1 === -1 && index2 === -1) {
            $scope.displayOrder.push(1)
          } else if (index1 !== -1) {
            $scope.displayOrder[index1] = 2
          } else if (index2 !== -1) {
            $scope.displayOrder[index2] = 1
          }
        })
      }
    },
    link: {
      pre: (scope, element, attrs) => {

        scope.availableProperties = []
        scope.properties = []
        scope.displayOrder = []

        scope.newProperty = null
        scope.fieldsOptions = fields

        for (const key in scope.myFields) {
          if (scope.myFields[key].output && scope.myFields[key].output.sortable) {
            scope.availableProperties.push(scope.myFields[key].label)
          }
        }

        if (valueHandler.isArray(scope.myDefaultOrder)) {
          for (let index = 0; index < scope.myDefaultOrder.length; index++) {
            const propertyName = scope.myDefaultOrder[index].toString().replace('-', '')
            const property = scope.myFields[propertyName]
            scope.properties.push(property)
            scope.myOrder.push(propertyName)
            if (scope.myDefaultOrder[index].toString().match('-')) {
              scope.displayOrder.push(2)
            } else {
              scope.displayOrder.push(1)
            }
          }
        }
      },
      post: (scope, element, attrs, ctrl) => {
        const sortInput = angular.element('#sortInput')
        sortInput.bind('keyup', (event) => {
          const keyName = event.key

          if (keyName === 'Enter') {
            $timeout(() => {
              scope.addProperty(scope.propertyName)
            }, 250)
          }
        })
      },
    },
  }
}
export default myChooseOrder



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/tables/myChooseOrder.js